<template>
  <div class="field is-horizontal">
    <DiceFormField :label="'AT'" :dice="attack.attack"></DiceFormField>
    <DiceFormField :label="'POW'" :dice="attack.damage"></DiceFormField>
    <div class="field">
      <a :disabled="!canRemoveAttack" class="button is-white" @click="removeAttack">
        <span class="icon is-left"><span class="fas fa-trash"></span></span>
      </a>
    </div>
  </div>
</template>

<script>
import DiceFormField from "./DiceFormField";
export default {
  name: "AttackFormField",
  components: { DiceFormField },
  props: {
    attack: {
      type: Object,
      required: true
    },
    canRemoveAttack: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    removeAttack() {
      if (this.canRemoveAttack) this.$store.dispatch("removeAttack", this.attack);
    }
  }
};
</script>
